/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { FSBTable } from 'components/common/FSBTable';
import { invoicesCategoryColumns } from 'pages/Invoices/constants';
import {
  INVOICES_QUERY,
  INVOICES_QUERY_SUBSCRIPTION,
} from 'pages/Invoices/InvoicesGraphQL';
import { cloneDeep, isEmpty } from 'lodash';
import { useDispatch } from 'react-redux';
import { setUserDetails } from 'actions/userDetailsAction';
import { USER_ID, showSequenceNumber } from 'utils/constants';
import Loader from 'components/common/Loader';
import ErrorMessage from 'components/ErrorMessage';
import NoDataFound from 'components/NoDataFound';
import InvoiceMobileList from 'pages/Invoices/components/InvoiceMobileList';

const FullyPaidTable = ({ searchString, handleViewDetail }) => {
  const dispatch = useDispatch();
  const [filters, setFilters] = useState({
    filter: [
      {
        key: 'tradeName',
        innerAttributeName: 'buyer',
        joinAttributeName: 'order',
        value: searchString,
        type: 'STRING',
        op: 'LIKE_OR_NULL',
      },
      { key: 'invoiceStatus', value: 'PAID_FULL', type: 'STRING', op: 'EQ' },
    ],
    pageNo: 1,
    pageSize: 10,
    sortCol: 'createdAt',
    sortDirection: 'DESC',
  });

  const { data, loading, error, refetch, subscribeToMore } = useQuery(
    INVOICES_QUERY,
    {
      variables: filters,
      fetchPolicy: 'network-only',
    },
  );

  const handlePageChange = ({ pageSize, pageNo }) => {
    setFilters({
      ...filters,
      pageNo: data?.invoices?.totalCount < pageSize ? 1 : pageNo,
      pageSize,
    });
  };
  const onSortChange = (sort) => {
    setFilters({
      ...filters,
      sortCol: sort()[0].id,
      sortDirection: sort()[0].desc ? 'DESC' : 'ASC',
    });
  };

  const sortBy = [
    filters.sortCol === null
      ? { id: null, desc: null }
      : {
          id: filters.sortCol,
          desc: filters.sortDirection === 'DESC',
        },
  ];

  const handleLinkClick = (row) => {
    handleViewDetail(row);
  };
  const linkFormatter = (cell) => {
    return (
      <div
        className="text-blue-c5 fw-medium cursor-pointer"
        onClick={() => handleLinkClick(cell?.row?.original)}
        aria-hidden
      >
        {cell?.row?.original?.id}
      </div>
    );
  };
  const handleUserId = (row, id) => {
    dispatch(setUserDetails({ status: true, selectedUser: { ...row, id } }));
  };

  const linkFormatterForUserId = (cell, userId) => {
    return (
      <div
        className="text-blue-c5 fw-medium cursor-pointer"
        onClick={() =>
          handleUserId(cell?.row?.original, cell?.row?.original?.[userId])
        }
        aria-hidden
      >
        {cell?.row?.original?.[userId]}
      </div>
    );
  };

  const findIndexOfItem = (item) => {
    return invoicesCategoryColumns.findIndex((itm) => itm.accessorKey === item);
  };
  invoicesCategoryColumns[findIndexOfItem('id')].cell = linkFormatter;
  invoicesCategoryColumns[findIndexOfItem('SNo')].cell = (cell) =>
    showSequenceNumber(cell, filters);
  invoicesCategoryColumns[findIndexOfItem(USER_ID.CREATED_ID)].cell = (cell) =>
    linkFormatterForUserId(cell, USER_ID.CREATED_ID);
  invoicesCategoryColumns[findIndexOfItem(USER_ID.UPDATED_ID)].cell = (cell) =>
    linkFormatterForUserId(cell, USER_ID.UPDATED_ID);

  useEffect(() => {
    const updatedFilter = [...filters.filter]; // Clone the filter array
    const updatedFirstFilter = { ...updatedFilter[0] }; // Clone the 0th filter object
    updatedFirstFilter.value = searchString;
    updatedFilter[0] = updatedFirstFilter; // Replace the 0th filter with the updated one
    // return { ...prevFilter, filter: updatedFilter }; // Update the filter property in the state
    refetch({ ...filters, filter: updatedFilter });
  }, [searchString]);

  const onGlobalSearch = (str) => {
    if (str) {
      setFilters((prevFilter) => {
        const updatedFilter = [...prevFilter.filter]; // Clone the filter array
        const updatedFirstFilter = { ...updatedFilter[0] }; // Clone the 0th filter object
        updatedFirstFilter.value = str;
        updatedFilter[0] = updatedFirstFilter; // Replace the 0th filter with the updated one
        return { ...prevFilter, filter: updatedFilter }; // Update the filter property in the state
      });
    }
  };
  useEffect(() => {
    const unsubscribe = subscribeToMore({
      document: INVOICES_QUERY_SUBSCRIPTION,
      variables: { ...filters },
      updateQuery: (prev, { subscriptionData }) => {
        const newData = cloneDeep(prev);
        const indexFound = newData.invoices.invoices.findIndex(
          (val) => val.id === subscriptionData?.data?.invoices?.invoice?.id,
        );
        if (!prev || isEmpty(prev)) return '';
        if (!subscriptionData?.data) return prev;
        if (!subscriptionData.data?.invoices?.invoice?.id) return prev;
        if (subscriptionData?.data?.invoices?.action === 'CREATED') {
          const newInvoices = subscriptionData?.data?.invoices?.invoice;
          const updatedInvoices = [newInvoices, ...newData.invoices.invoices];

          const newTotalCount = prev.invoices.totalCount + 1;
          const newTotalPages = Math.ceil(newTotalCount / filters.pageSize);

          newData.invoices = {
            ...newData.invoices,
            totalCount: newTotalCount,
            totalPages: newTotalPages,
            invoices: updatedInvoices,
          };
        }
        if (subscriptionData?.data?.invoices?.action === 'UPDATED') {
          newData.invoices.invoices[indexFound] =
            subscriptionData.data.invoices.invoice;
        }

        if (subscriptionData?.data?.invoices?.action === 'DELETED') {
          const { id } = subscriptionData.data.invoices.invoice; // ID of the invoice to remove
          const prevInvoices = prev.invoices.invoices;

          const updatedInvoices = prevInvoices.filter((val) => val.id !== id);

          const newTotalCount = prev.invoices.totalCount - 1;
          const newTotalPages = Math.ceil(newTotalCount / filters.pageSize);

          const updatedInvoicesData = {
            ...newData.invoices,
            totalCount: newTotalCount,
            totalPages: newTotalPages,
            invoices: updatedInvoices,
          };
          newData.invoices = updatedInvoicesData;
        }

        return newData;
      },
    });

    return () => unsubscribe();
  }, []);

  if (loading)
    return (
      <div className="mt-2 pt-1">
        <Loader />
      </div>
    );
  if (error) {
    return <ErrorMessage error={error} />;
  }
  if (!data?.invoices?.invoices)
    return <NoDataFound message="Invoices not available" />;

  return (
    <>
      <InvoiceMobileList
        invoices={(data && data?.invoices?.invoices) || []}
        totalPages={(data && data?.invoices?.totalPages) || 0}
        currentPageNo={filters.pageNo}
        pageSize={filters.pageSize}
        handlePageChange={handlePageChange}
        handleInvoiceClick={handleLinkClick}
        handleUserId={handleUserId}
      />
      <div className="invoice-mobile-hide-table">
        <FSBTable
          data={(data && data?.invoices?.invoices) || []}
          totalCount={(data && data?.invoices?.totalCount) || 0}
          totalPages={(data && data?.invoices?.totalPages) || 0}
          columns={invoicesCategoryColumns}
          currentPageNo={filters.pageNo}
          pageSize={filters.pageSize}
          keyField="id"
          showSearch={false}
          showFilters
          showDelete={false}
          showPagination
          remote
          striped={false}
          hover={false}
          bordered={false}
          wrapperClass="table-responsive word-break"
          handlePageChange={handlePageChange}
          globalSearchStr={filters.filter[0].value}
          onGlobalSearch={onGlobalSearch}
          onSortChange={onSortChange}
          sorting={sortBy}
          searchPlaceholder="Search Vendors"
        />
      </div>
    </>
  );
};
export default FullyPaidTable;
